import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

let analytics = null;

const firebaseConfig = {
  apiKey: "AIzaSyBwInVXvfArkKh_R3sp5H9r8Ll3Q6K_O1M",
  authDomain: "academia-prod-c868b.firebaseapp.com",
  projectId: "academia-prod-c868b",
  storageBucket: "academia-prod-c868b.firebasestorage.app",
  messagingSenderId: "568741360383",
  appId: "1:568741360383:web:6eea320c7275566db7d2ca",
  measurementId: "G-GQYM4H3WGW",
};

export const firebaseApp = getApps().length
  ? getApps()[0]
  : initializeApp(firebaseConfig);

export const initAnalytics = async () => {
  try {
    if (typeof window !== "undefined" && (await isSupported())) {
      analytics = getAnalytics(firebaseApp);
    }
  } catch (_) {}
  return analytics;
};

export const getAnalyticsInstance = () => analytics;

export const logAnalyticsEvent = (name, params) => {
  if (analytics) {
    logEvent(analytics, name, params);
  }
};
